exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".attention-title[data-v-187f3cb2] {\n  width: 120px;\n  font-size: 13px;\n  color: #9f9f9f;\n  position: absolute;\n  top: 25px;\n  left: 70px;\n}\n.tipsBox[data-v-187f3cb2] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  font-size: 13px;\n  color: #9f9f9f;\n}\n.tipsBox span[data-v-187f3cb2] {\n  margin-left: 5px;\n}\n.label-color[data-v-187f3cb2] {\n  font-weight: 800;\n  color: #f56c6c;\n}", ""]);

// exports
